export const DateRangeSelector = ({
	quickRangeOptions,
	selectedDateRange,
	handleOnRangeClick
}) => {
	return (
		<div className="dashboard-range-selection-container">
			<div className="dashboard-range-title">
				Choose a quick range
			</div>
			<div className="dashboard-range-options">
				{quickRangeOptions.map((option, index) => (
					<div
						key={index}
						className={`range-option ${selectedDateRange === option ? 'selected' : ''}`}
						onClick={() => handleOnRangeClick(option)}>
						{option}
					</div>
				))}
			</div>
		</div>
	);
};